// extracted by mini-css-extract-plugin
module.exports = {"successLabel":"UBjA2","successIcon":"FNvyf"};